import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Field } from 'react-final-form';
import { withStyles } from '@material-ui/core';

const styles = {
  root: {
    width: 'inherit'
  }
};

class CheckBoxInput extends React.Component {
  onCheckBoxSelectChange = input => {
    input.onChange();
    this.props.onChange();
  };

  render() {
    const { label, input, className } = this.props;
    let name = input.name;
    const { classes, disabled = false } = this.props;
    return (
      <div className={className}>
        <FormControl {...input} classes={{ root: classes.root }}>
          <Checkbox
            name={name}
            color="primary"
            checked={!!input.value}
            onChange={() => this.onCheckBoxSelectChange(input)}
            type="checkbox"
            disabled={disabled}
          />
        </FormControl>
        <InputLabel htmlFor={label} className={classes.labelStyle}>
          {label}
        </InputLabel>
      </div>
    );
  }
}

const CheckBox = props => <Field component={CheckBoxInput} {...props} />;
export default withStyles(styles)(CheckBox);
